import type { AuthGoogleRequest, AuthGoogleResponse } from '@lemoment/shared';

import { apiClient } from '../../../core';

export const loginWithGoogle = (idToken: string): Promise<AuthGoogleResponse> =>
  apiClient.post('/auth/google', { idToken } satisfies AuthGoogleRequest);
